import React from "react";
import {
    Box,
    Paper,
    Stack,
    Typography,
    Divider,
    IconButton,
    Chip,
    Tooltip,
    List,
    ListItem,
    ListItemText,
    CircularProgress,
    Grid,
} from "@mui/material";
import { labelStyle, subTextStyle } from "./commonStyles";
import moment from "moment";
import CustomButton from "components/Button";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import { getPermissions } from "./dmsPermissions";
import { useGetFileCommentsQuery } from "store/slices/apis/dmsSlice";


function formatBytes(bytes) {
    if (!bytes && bytes !== 0) return "-";
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 B";
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const val = bytes / Math.pow(1024, i);
    return `${val.toFixed(val >= 10 || i === 0 ? 0 : 1)} ${sizes[i]}`;
}

function fileTypeFromName(name = "") {
    const ext = name.split(".").pop()?.toLowerCase();
    return ext ? ext.toUpperCase() : "FILE";
}

const FileVersions = ({
    selectedDoc,
    handleDownload,
    handleUpload,
    handleRollback,
    loadingKey,
    selectedFolderName,
    permissionList,
    onOpenCommentModal,
    userEmail,
    isAdmin
}) => {
    // const checkPermission = (fileId) => {
    //     console.log("fileId", fileId);
    //     const findedItem = permissionList?.find(item => item.resourceId === fileId && item.permissionType !== "View")
    //     if (findedItem) {
    //         return true;
    //     }
    //     return false;
    // }
    const perms = selectedDoc
        ? getPermissions(selectedDoc.fileId, "File", permissionList, userEmail, isAdmin)
        : null;

    const {
        data: comments,
        isLoading: commentsLoading,
    } = useGetFileCommentsQuery(selectedDoc?.fileId, {
        skip: !selectedDoc?.fileId,
    });

    return (
        <Paper
            sx={{
                width: "30%",
                minWidth: 320,
                p: 1.5,
                borderRadius: "3px",
                overflow: "auto",
                border: "1px solid #E2E8F0"
            }}
        >
            <Typography sx={labelStyle}>Details</Typography>
            <Divider sx={{ my: 1 }} />

            {!selectedDoc ? (
                <Box sx={{ mt: 2 }}>
                    <Typography sx={labelStyle}>
                        Select a document
                    </Typography>
                    <Typography sx={subTextStyle}>
                        Click a row to view details, version history, and actions.
                    </Typography>
                </Box>
            ) : (
                <Box>
                    <Typography sx={{ fontSize: "15px", fontWeight: 700 }} noWrap>
                        {selectedDoc.fileName}
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: "wrap" }}>
                        <Chip size="small" label={`v${selectedDoc?.currentVersion}`} />
                        <Chip
                            size="small"
                            variant="outlined"
                            label={fileTypeFromName(selectedDoc?.fileName)}
                        />
                        <Chip
                            size="small"
                            variant="outlined"
                            label={formatBytes(selectedDoc?.fileSize)}
                        />
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    <Stack spacing={0.6}>
                        <Typography sx={subTextStyle}>
                            <b>Uploaded by:</b> {selectedDoc?.createdBy}
                        </Typography>
                        <Typography sx={subTextStyle}>
                            <b>Date:</b>{" "}
                            {moment(selectedDoc.createdDate).format("DD-MM-YYYY")}
                        </Typography>
                        <Typography sx={subTextStyle}>
                            <b>Linked to:</b>{" "}
                            {/* {(selectedDoc.linkedTo || [])
                                .map((x) => `${x.type} ${x.id}`)
                                .join(", ") || "-"} */}
                            {selectedFolderName}
                        </Typography>
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    <Stack direction="row" spacing={1}>
                        {/* <Button
                    fullWidth
                    variant="contained"
                    startIcon={<DownloadOutlinedIcon />}
                    onClick={() => handleDownload(selectedDoc.id)}
                  >
                    Download
                  </Button> */}
                        {perms?.canDownload && <CustomButton
                            label="Download"
                            startIcon={loadingKey === "main" ? <CircularProgress size="16px" /> : <DownloadOutlinedIcon />}
                            color="primary"
                            onClick={() => handleDownload(selectedDoc.fileId, selectedDoc.currentVersion, selectedDoc.fileName, "main")}
                            sx={{
                                backgroundColor: "#00344C",
                                fontFamily: "Outfit",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "100%",
                                letterSpacing: "0px",
                                flex: 0.8,
                            }}
                            disabled={loadingKey === "main"}

                        />}
                        {/* <Button fullWidth variant="outlined" onClick={handleUpload}>
                    Upload New Version
                  </Button> */}
                        {perms?.canUpload && <CustomButton
                            label="Upload New Version"
                            startIcon={<CloudUploadOutlinedIcon />}
                            color="primary"
                            onClick={handleUpload}
                            sx={{
                                backgroundColor: "#00344C",
                                fontFamily: "Outfit",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "100%",
                                letterSpacing: "0px",
                                flex: 1,
                            }}
                        />}
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    <Typography sx={labelStyle}>Versions</Typography>
                    <List dense sx={{ mt: 0.5 }}>
                        {selectedDoc?.versions?.map((v) => (
                            <ListItem
                                key={v.versionNumber}
                                secondaryAction={
                                    <Stack direction="row" spacing={0.5}>
                                        {perms?.canDownload && <Tooltip title="Download this version">
                                            <IconButton
                                                size="small"
                                                onClick={() => {

                                                    console.log("download version", v.versionNumber)
                                                    handleDownload(selectedDoc.fileId, v.versionNumber, v?.fileName, v.versionNumber)
                                                }
                                                }
                                            >
                                                {loadingKey === v.versionNumber ? <CircularProgress size={"15px"} /> : <DownloadOutlinedIcon fontSize="small" />}
                                            </IconButton>
                                        </Tooltip>}
                                        {/* {v.versionNumber !== selectedDoc.currentVersion && (
                                            <Tooltip title="Rollback (set as current)">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleRollback(v.versionNumber)}
                                                >
                                                    <RestoreOutlinedIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        )} */}
                                    </Stack>
                                }
                            >
                                <ListItemText
                                    primary={
                                        <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                                            v{v.versionNumber} •{" "}
                                            {v.createdDate
                                                ? moment(v.createdDate).format("DD-MM-YYYY")
                                                : ""}
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography sx={subTextStyle}>
                                            {v.by}
                                            {v.note ? ` • ${v.note}` : ""}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        ))}
                        {selectedDoc?.versions.length === 0 && (
                            <Typography sx={subTextStyle}>
                                No version history found.
                            </Typography>
                        )}
                    </List>


                    <Divider sx={{ my: 1.5 }} />

                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography sx={labelStyle}>Comments</Typography>

                        {perms?.canComment && (
                            <CustomButton
                                label="Add Comment"
                                color="primary"
                                onClick={() => onOpenCommentModal()}
                                sx={{
                                    backgroundColor: "#00344C",
                                    fontFamily: "Outfit",
                                    fontWeight: 500,
                                    fontSize: "13px",
                                    lineHeight: "100%",
                                }}
                            />
                        )}
                    </Stack>

                    <Box
                        sx={{
                            height: 220,
                            border: "1px solid #E5E7EB",
                            borderRadius: 2,
                            p: 1.5,
                            mt: 1,
                            overflowY: "auto"
                        }}
                    >
                        {comments?.data?.length > 0 ? (
                            comments?.data?.map((comment, index) => (
                                <Box key={index} sx={{ mb: 1 }}>
                                    <Grid container justifyContent="space-between">
                                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                            {comment?.createdBy}
                                        </Typography>
                                        <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                                            {moment(comment?.createdDate).format("DD-MM-YYYY HH:mm")}
                                        </Typography>
                                    </Grid>
                                    <Typography sx={{ fontSize: 13 }}>
                                        {comment?.comment}
                                    </Typography>
                                    <Divider sx={{ mt: 1 }} />
                                </Box>
                            ))
                        ) : (
                            <Typography sx={subTextStyle}>
                                No comments available.
                            </Typography>
                        )}
                    </Box>

                </Box>
            )}
        </Paper>
    );
};

export default FileVersions;
